import React from 'react'
import { X } from 'lucide-react'

type CloseBtnProps = {
  setIsClosed: (isClosed: boolean) => void
}

const CloseBtn: React.FC<CloseBtnProps> = ({ setIsClosed }: CloseBtnProps) => {
  return (
    <button
      className="absolute right-0 top-0 z-10 m-2 rounded-full p-2"
      onClick={() => setIsClosed(true)}
    >
      <X size={24} className="font-semibold text-white" />
    </button>
  )
}

export { CloseBtn }
